import React from 'react'

interface DangerButtonProps {
  children: React.ReactNode
  onClick: () => void
  type?: 'button' | 'submit'
}

const DangerButton = ({ children, onClick, type = 'button' }: DangerButtonProps): JSX.Element => {
  return (
    <button
      type={type}
      onClick={onClick}
      className="px-3 py-2 bg-buttons-button-danger rounded-md flex justify-center items-center gap-1.5 overflow-hidden"
      style={{
        boxShadow:
          '0px 0px 0px 1px rgba(190,18,60,1.00), 0px 1px 2px 0px rgba(190,18,60,0.40), inset 0px 0.75px 0px 0px rgba(255,255,255,0.20)'
      }}>
      <div className="text-buttons-text-primary text-sm font-semibold font-Montserrat leading-5">{children}</div>
    </button>
  )
}

export default DangerButton
